// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aSn-","label":"styles_label__10ZMt"};